// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyB8qtQW8hnB_T3SJ5fy0y37-IFUhA8k0TE",
  authDomain: "h1store.firebaseapp.com",
  projectId: "h1store",
  storageBucket: "h1store.appspot.com",
  messagingSenderId: "658823936183",
  appId: "1:658823936183:web:a336eee4d798c00ec07532",
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
